import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';
import { BazisInputDateintervalComponent } from '@bazis/form/components/datetime/input-dateinterval.component';
import moment from 'moment';
import { map, shareReplay, startWith } from 'rxjs';

@Component({
    selector: 'app-menu-input-date-interval',
    templateUrl: './menu-input-date-interval.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MenuInputDateintervalComponent
    extends BazisInputDateintervalComponent
    implements OnInit {
    @HostBinding('class') get hostClass() {
        return {
            'tms-date-filter': true,
            [this.cssClassSizeControl]: true,
            'tms-date-filter_outline': this.fillType === 'outline',
        };
    }

    @Input() calendarsNumber = 1;

    @Input() fillType: 'fill' | 'outline' = 'fill';

    // количество отфильтрованного на данную дату или интервал дат.
    @Input() amount;

    @Output() startCalendarChange: EventEmitter<{ year: number; month: number }> =
        new EventEmitter();

    todayDate = moment();

    today;

    buttonStatus$;

    diffDays = 0;

    ngOnInit() {
        super.ngOnInit();

        this.today = this.todayDate.format(this.displayFormat);

        this.buttonStatus$ = this.value.valueChanges.pipe(
            startWith(this.value.value),
            map((value) => {
                this.diffDays =
                    (moment(value.to, this.displayFormat).valueOf() -
                        moment(value.from, this.displayFormat).valueOf()) /
                        (1000 * 60 * 60 * 24) +
                    1;
                return {
                    nextEnabled:
                        !this.maxDate ||
                        ((!this.value.value.to
                            ? moment(value.from, this.displayFormat).isBefore(
                                  moment(this.maxDate, 'YYYY-MM-DD'),
                                  'day',
                              )
                            : moment(value.to, this.displayFormat).isBefore(
                                  moment(this.maxDate, 'YYYY-MM-DD'),
                                  'day',
                              )) &&
                            this.maxDate),
                    prevEnabled:
                        !this.minDate ||
                        moment(value.from, this.displayFormat).isAfter(
                            moment(this.minDate, 'YYYY-MM-DD'),
                            'day',
                        ),
                };
            }),
            shareReplay(SHARE_REPLAY_SETTINGS),
        );
    }

    changeDate(diff = 1) {
        if (!this.value.value.from && !this.value.value.to) {
            this.value.setValue({ from: this.today, to: null });
            return;
        }
        if (this.value.value.from && !this.value.value.to) {
            let currentDate = moment(this.value.value.from, this.displayFormat);
            currentDate = currentDate.add(diff, 'day');
            this.value.patchValue({ from: currentDate.format(this.displayFormat) });
            return;
        }

        if (this.value.value.from && this.value.value.to) {
            let currentFromDate = moment(this.value.value.from, this.displayFormat);
            currentFromDate = currentFromDate.add(this.diffDays * diff, 'day');

            let currentToDate = moment(this.value.value.to, this.displayFormat);
            currentToDate = currentToDate.add(this.diffDays * diff, 'day');

            if (
                this.minDate &&
                moment(currentFromDate, this.displayFormat).isBefore(
                    moment(this.minDate, 'YYYY-MM-DD'),
                    'day',
                )
            ) {
                currentFromDate = moment(this.minDate, this.displayFormat);
            }

            if (
                this.maxDate &&
                moment(currentToDate, this.displayFormat).isAfter(
                    moment(this.maxDate, 'YYYY-MM-DD'),
                    'day',
                )
            ) {
                currentToDate = moment(this.maxDate, this.displayFormat);
            }

            this.value.patchValue({
                from: currentFromDate.format(this.displayFormat),
                to: currentToDate.format(this.displayFormat),
            });
            return;
        }
    }
}
